import {createContext} from "react";

export const ImageDropFieldContext = createContext({
    openFileSelector: () => {},
    importLoading: false,
    disabled: false,
    inputProps: {},
    rootProps: {},
    fileRejections: [],
})
